export const links = [
  {
    id: 1,
    text: "Players",
    dropdown: [
      {
        id: 1.1,
        text: "Players List",
        url: "/players-list"
      },
      // {
      //   id: 1.2,
      //   text: "Scouting Report",
      //   url: "/scouting-report"
      // },
      {
        id: 1.2,
        text: "Scouting Reports",
        url: "/scouting-reports"
      },
      {
        id: 1.3,
        text: "Favourite Reports",
        url: "/favourite-reports"
      },
      {
        id: 1.4,
        text: "My Guys",
        url: "/my-guys",
      },
    ],
  // },
  //   url: "/",
  },
  // {
  //   id: 2,
  //   text: "My Guys",
  //   url: "/my-guys",
  // },
  {
    id: 2,
    text: "Mock Draft Simulator",
    url: "/select-draft",
  },
  {
    id: 3,
    text: "Draft Value Chart",
    url: "/draft-value-chart",
  },
  {
    id: 4,
    text: "Team Needs",
    url: "/team-needs",
  },
];

